import type { ProjectLog } from '../api/types'
import { fromLocalInput } from './time'

/** What a project log can be about, in the words the form shows. */
export const LOG_CATEGORIES: { value: ProjectLog['category']; label: string }[] = [
  { value: 'note', label: 'Note' },
  { value: 'maintenance', label: 'Maintenance' },
  { value: 'incident', label: 'Incident' },
]

export const LOG_NOTE_MAX = 2000

export function categoryLabel(category: ProjectLog['category']): string {
  return LOG_CATEGORIES.find((c) => c.value === category)?.label ?? category
}

/** The form's two wall-clock boxes as instants, read in station time (a
 *  browser in any zone sends the same ones), or null while either is
 *  incomplete or the end is not after the start. */
export function logRange(start: string, end: string): { starts_at: string; ends_at: string } | null {
  const from = fromLocalInput(start)
  const until = fromLocalInput(end)
  if (!Number.isFinite(from.getTime()) || !Number.isFinite(until.getTime()) || until <= from) return null
  return { starts_at: from.toISOString(), ends_at: until.toISOString() }
}
